import { spaceAPI } from '@/api';
import CommonSpaceDetailContainer, {
  FieldConfig,
} from '@/components/common/CommonSpaceDetailContainer';
import ResomHeader from './ResomHeader';
import { palette } from '@/modules/defines/styles';

interface DataType {
  id?: number;
  title: string;
  description: string;
  address: string;
  address_lat: string;
  address_long: string;
  category: string;
  floor_default: string | null;
  img: string;
  link: string;
  phone: string;
  thumbnail: string | null;
  time: string;
  type: string;
  updatedAt?: string;
  use_app: boolean;
}

const categoryMap: { [key: string]: string } = {
  '11': '객실',
  '12': 'F&B',
  '13': '스파',
  '7': '테마정원',
  '14': '연회장',
  '15': '부대시설',
};

const typeMap: { [key: string]: string } = {
  resom_restree: '레스트리',
  resom_forestclub: '포레스트클럽',
  resom_outside: '야외',
};

const fields: FieldConfig<DataType>[] = [
  {
    name: 'title',
    label: '이름',
    type: 'text',
    description: '공간의 이름을 입력해주세요',
    width: 'full',
  },
  {
    name: 'description',
    label: '설명',
    type: 'textarea',
    description: '공간에 대한 자세한 설명을 입력해주세요',
    width: 'full',
  },
  {
    name: 'category',
    label: '카테고리',
    type: 'select',
    options: Object.entries(categoryMap).map(([key, value]) => ({
      value: key,
      label: value,
    })),
    description: '공간의 카테고리를 선택해주세요',
    width: 'half',
  },
  {
    name: 'type',
    label: '타입',
    type: 'select',
    options: Object.entries(typeMap).map(([key, value]) => ({
      value: key,
      label: value,
    })),
    description: '공간의 타입을 선택해주세요',
    width: 'half',
  },
  {
    name: 'floor_default',
    label: '층수',
    type: 'number',
    placeholder: '층수를 입력하세요',
    description: '공간이 위치한 층수를 입력해주세요 (선택사항)',
    width: 'full',
  },
  {
    name: 'address_lat',
    label: '위도',
    type: 'text',
    placeholder: '위도 좌표를 입력하세요',
    description: '위도 좌표 (예: 37.1234)',
    renderCondition: (formData) => formData.type === 'resom_outside',
    width: 'half',
  },
  {
    name: 'address_long',
    label: '경도',
    type: 'text',
    placeholder: '경도 좌표를 입력하세요',
    description: '경도 좌표 (예: 127.1234)',
    renderCondition: (formData) => formData.type === 'resom_outside',
    width: 'half',
  },
  {
    name: 'img',
    label: '이미지',
    type: 'image',
    description: '공간의 대표 이미지를 업로드해주세요',
    width: 'full',
  },
  {
    name: 'link',
    label: '링크',
    type: 'text',
    description: '공간과 관련된 웹페이지 링크를 입력해주세요',
    width: 'full',
  },
];

const ResomSpaceDetailContainer = () => {
  return (
    <CommonSpaceDetailContainer<DataType>
      HeaderComponent={ResomHeader}
      queryKey="getSpaceResom"
      listQueryKey="getSpacesResom"
      queryFn={(id) =>
      spaceAPI.getSpaceResom({
        code: import.meta.env.VITE_SECRET_API_KEY,
          id,
        })
      }
      updateFn={(id, data) =>
      spaceAPI.updateSpaceResom(
        {
          code: import.meta.env.VITE_SECRET_API_KEY,
        },
        {
            id,
          ...data,
        }
        )
      }
      uploadImageFn={(id, file) => {
      const formData = new FormData();
      formData.append('img', file);
      return spaceAPI.uploadSpaceResomImage(
        {
          code: import.meta.env.VITE_SECRET_API_KEY,
          id: id,
        },
        formData
      );
      }}
      fields={fields}
      switchFieldKey="use_app"
      switchFieldLabel="앱에서 사용"
      defaultRoute="/resom/space"
      themeColor={palette.main900}
      themeHoverColor={palette.main800}
    />
  );
};

export default ResomSpaceDetailContainer;
